import { useCallback, useState } from "react";

const useHaklaiNotice = () => {
  const [haklaiNotice, setHaklaiNotice] = useState({ open: false, message: "" });

  const showHaklaiNotice = useCallback((message) => {
    setHaklaiNotice((prev) => (
      prev.open && prev.message === message
        ? prev
        : { open: true, message }
    ));
  }, []);

  const dismissHaklaiNotice = useCallback(() => {
    setHaklaiNotice((prev) => (prev.open ? { ...prev, open: false } : prev));
  }, []);

  const closeHaklaiNotice = useCallback((event, reason) => {
    if (reason === "clickaway") return;
    dismissHaklaiNotice();
  }, [dismissHaklaiNotice]);

  return {
    closeHaklaiNotice,
    dismissHaklaiNotice,
    haklaiNotice,
    showHaklaiNotice
  };
};

export default useHaklaiNotice;
